<template>
  <div class="mt-3">
    <div class="d-flex mb-3">
      <div class="w-100">
        <div class="input-group mb-3 ">
          <div class="input-group-prepend">
            <div class="input-group-text toggle-custom">
              <toggle-button
                :width="80"
                :labels="{checked: 'Public', unchecked: 'Private'}"
                :height="24"
                :margin="0"
                :padding="0"
                :sync="true"
                @change="campaignType"
              />
            </div>
          </div>
          <input
            v-model="keyword"
            type="text"
            class="form-control"
            placeholder="Find product"
            @keyup.enter="fetch"
          >
          <div class="input-group-append">
            <button
              class="btn btn-outline-secondary "
              type="button"
              @click="fetch"
            >
              Search
            </button>
          </div>
        </div>
      </div>
      <div class="ml-2">
        <button
          class="btn"
          :class="{'btn-light': filterSelected == false,'btn-success': filterSelected == true}"
          @click="filterSelect"
        >
          <i class="dripicons-checkmark" />
        </button>
      </div>
    </div>

    <div
      id="result"
      class="d-flex align-content-start flex-wrap"
    >
      <result-not-found :result="products" />
      <div
        v-for="item in products"
        :key="item.id"
        class="item-container"
        @click="choice(item)"
      >
        <div class="item">
          <div class="thumb">
            <img
              :title="item.name.trim()"
              :src="item.thumb"
            >
            <div
              v-if="item.select == true"
              class="choiced"
            >
              <i class="dripicons-checkmark" />
            </div>
          </div>
        </div>
        <div class="name">
          {{ item.name.trim() }}
        </div>
      </div>
    </div>

    <div
      v-if="products.length > 0"
      class="mt-4"
    >
      <nav>
        <ul class="pagination justify-content-center ">
          <li
            class="page-item "
            :class="{disabled:page == 1}"
          >
            <a
              class="page-link"
              href="#result"
              tabindex="-1"
              @click="previous"
            >Previous</a>
          </li>
          <li class="page-item ">
            <span class="page-link text-muted">{{ (page - 1) * limit }} - {{ page*limit }}</span>
          </li>
          <li
            class="page-item"
            :class="{disabled: products.length == 0}"
          >
            <a
              class="page-link"
              href="#result"
              @click="next"
            >Next</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
    import ResultNotFound from "@/components/ResultNotFound";

    export default {
        name: "CampainModal",
        components: {ResultNotFound},
        props: {
            'data': {
                default: []
            }
        },
        data: function () {
            return {
                filterSelected: false,
                products: [],
                keyword: '',
                cursor: '',
                select: false,
                type: true,
                page: 1,
                limit: 10,

            }
        },
        watch: {
            type: function () {
                this.page = 1
                this.fetch()
            },
            data: function (val) {
                this.isSelected(val)
            },
            filterSelected: function () {
                this.fetch()
            }

        },
        mounted: async function () {
            await this.fetch()
        },
        methods: {
            isSelected: function (val) {
                for (let i = 0; i < val.length; i++) {
                    let x = this.$_.findIndex(this.products, ['id', val[i]])
                    if (x > -1) {
                        this.$set(this.products[x], 'select', true)
                    }
                }
            },
            filterSelect: function () {
                this.filterSelected = this.filterSelected == true ? false : true
            },
            previous: function () {
                if (this.page > 1) {
                    this.page = this.page - 1
                }
                this.fetch()
            },
            next: function () {
                this.page = this.page + 1
                this.fetch()
            },
            campaignType: function () {
                this.type = this.type ? false : true
            },
            fetch: async function () {

                let vm = this
                let query = '?public=' + this.type

                if (this.keyword != '') {
                    query += '&keyword=' + encodeURIComponent(this.keyword)
                }

                let offset = (this.page - 1) * this.limit
                query += '&limit=' + this.limit
                query += '&offset=' + offset


                if (this.data.length > 0 && this.filterSelected == true) {
                    query += '&selected=' + encodeURIComponent(this.data.join(','))
                }

                let res = await this.$http.get(this.$config.api + 'campaigns' + query)
                vm.products = res.data.results
                this.isSelected(this.data)

            },
            choice: function (item) {
                // console.log(item)
                if (item.select && item.select == true) {
                    // item.select == false
                    this.$set(this.products[this.products.indexOf(item)], 'select', false)
                } else {
                    // item.select = true
                    this.$set(this.products[this.products.indexOf(item)], 'select', true)

                }
                let idx = this.data.indexOf(item.id)

                if (idx == -1) {
                    // this.selectedColor.splice(this.selectedColor.indexOf(color), 1);
                    // this.$delete(this.selected, this.selectedColor.indexOf(color))
                    this.data.push(item.id)
                    this.$emit('choiced', item.id)
                } else {
                    this.$delete(this.data, idx)
                    this.$emit('removed', item.id)
                }


            }

        }

    }
</script>

<style lang="scss" scoped>
    .toggle-custom {
        background-color: rgb(191, 203, 217);
        padding: 0 10px;
        label {
            padding: 0;
            margin: 0;
            .v-switch-core {
                border-radius: 0 !important;
            }
        }
    }

    .choiced {
        /* border: 1px solid #32c861;*/
        position: absolute;
        top: 5px;
        right: 5px;
        color: green;
    }

    .item-container {
        width: 20%;
        cursor: pointer;
        font-size: 85%;

        &:hover {
            border: 1px solid #ccc;
        }
        .item {
            width: 100%;
            padding-top: 100%; /* 1:1 Aspect Ratio */
            position: relative; /* If you want text inside of it */

        }

        /* If you want text inside of the container */
        .thumb {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            overflow: hidden;
            img {
                width: 100%;
                height: auto;
            }
        }

        .name {
            height: 30px;
            line-height: 30px;
            text-align: center;
            display: block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            padding: 0 10px;
        }

    }

    .page-item {
        width: 100px;
        text-align: center;
        &:last-child {

        }
    }

</style>